<div class="item_categoria">
  <li class="li_cont_item_categoria">
    <!-- Instance of sub-component comp-icono-flecha-dcha -->
    <div class="icono_flecha_dcha">
      <img
        src="assets/images/vectors82459780.svg"
        width="14.39990234375px"
        height="14.39990234375px"
        class="vector_vector"
      />
    </div>
    <div class="contenido_item_categoria">
      <a class="a_vinculo" (click)="ejecutarFuncion()">{{ nombre }}</a>
      <p class="descripcion_item_categoria" *ngIf="descripcion">
        {{ descripcion }}
      </p>
    </div>
    <app-icono-candado *ngIf="requiereAutenticacion"></app-icono-candado>
  </li>
</div>
